import React from "react";
import { Flex, Divider } from "@appsmith/ads";
import type { Tool } from "../types";
import { ToolCheckBox } from "./ToolCheckBox";
import { ToolCheckListItem } from "./ToolCheckListItem";

interface ToolCheckListProps {
  icon: React.ReactNode;
  onSelectAll: (tools: Tool[], setSelectedTo: boolean) => void;
  tools: Tool[];
  onToolSelect: (tool: Tool) => void;
  onToolEdit: (tool: Tool, triggerSave?: boolean) => void;
}

export const ToolCheckList = (props: ToolCheckListProps) => {
  const { icon, onSelectAll, onToolEdit, onToolSelect, tools } = props;

  const selectedCount = tools.filter((tool) => tool.isSelected).length;

  return (
    <Flex flexDirection="column" gap="spaces-2">
      <ToolCheckBox
        isEditing={false}
        isSelected={selectedCount === tools.length}
        label={selectedCount === tools.length ? "Deselect all" : "Select all"}
        onClick={() => onSelectAll(tools, selectedCount !== tools.length)}
      />
      <Flex px="spaces-4">
        <Divider />
      </Flex>
      {tools.map((tool) => {
        return (
          <ToolCheckListItem
            icon={icon}
            key={tool.entityId}
            onToolEdit={onToolEdit}
            onToolSelect={onToolSelect}
            tool={tool}
          />
        );
      })}
    </Flex>
  );
};
